import React from "react";
import { useNavigate } from "react-router-dom";
import AclManagement from "./AclManagement";

const AdminAclsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return <AclManagement onBack={handleBack} />;
};

export default AdminAclsPage;
